<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmModel = false"
              >Disagree</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            > Agree </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- <packageForm :formSchema="formSchema" v-on:emitCloseModal="close"></packageForm> -->
    <v-btn
      color="primary"
      dark
      slot="activator"
      class="mb-2"
      :to="`/procurement/new_package`"
      @click="_link"
      >New</v-btn
    >

    <v-card-title>
      <h2>Procurement Packages</h2>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    
    <div style="" id="auto">
      <v-data-table
        :headers="headers"
        :items="desserts"
        :pagination.sync="pagination"
        :total-items="totalDesserts"
        :loading="loading"
        class="elevation-4 my"
        
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ serial++ }}</td>
          <td class="text-xs-left">{{ props.item.package_no }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">
            <span v-if="props.item.is_change == 0">  </span>
            <span style="color:orange" v-else > Modified </span>
          <td>
          <td class="text-xs-left">
            <span v-if="props.item.status_id == 1" class="active">Plan</span>
            <span v-if="props.item.status_id == 2" class="in-active">Execute</span>
            <span v-if="props.item.status_id == 3" class="active">Revision</span>
            <span v-if="props.item.status_id == 4" class="in-active">Merge</span>
            <span v-if="props.item.status_id == 5" class="in-active">Split</span>
            <span v-if="props.item.status_id == 6" class="in-active">Close</span>
            <span v-if="props.item.status_id == 7" class="in-active">Cancel</span>
            <span v-if="props.item.status_id == 8" class="in-active">Procured</span>
            <span v-if="props.item.status_id == 9" class="in-active">In-Active</span>
          </td>
          
          <td class="text-xs-left">{{ props.item.type_name }}</td>
          <!-- <td class="text-xs-left">{{ props.item.unit_name }}</td>
          <td class="text-xs-left">{{ props.item.quantity }}</td> -->
          <td class="text-xs-left">{{ props.item.estimated_price | currency }}</td>
          <td class="text-xs-left">{{ props.item.method_name + '(' + props.item.market_approach + ')' }}</td>
          <td class="text-xs-left">{{ props.item.from_date }}</td>

          <td class="justify-center layout px-0" style="width:200px">

            <span v-if="props.item.status_id == 1 || props.item.status_id == 3" class="active">
              <v-btn icon class="mx-0" @click="editItem(props.index, props.item,'edit')" title="Edit">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn
              icon
              class="mx-0"
              @click="deleteItem(props.index, props.item.id)"
              title="Delete"
            >
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            </span>

            <span class="in-active">
              <v-btn icon class="mx-0" @click="addDetails(props.item)" title="Detail">
                <v-icon color="teal">view_module</v-icon>
              </v-btn>
              
            </span>

            <v-btn icon class="" @click="editItem(props.index, props.item,'copy')" title="Copy">
              <v-icon color="teal">file_copy</v-icon>
            </v-btn>

          </td>
        </template>

        <template slot="no-data" class="error">
          <div align="center">No Data Found</div>
        </template>
      </v-data-table>
    </div>  
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

//import packageForm from "./packageForm-2.vue";
import { preFix } from "../../../vuex/api";
import Axios from "axios";

export default {
  // components: {
  //   packageForm
  // },

  data: () => ({
    dialog: false,
    totalItems: 0,
 /**  data table */
    serialNumber: 0,
    sort: '',
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },
    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},
    
    headers: [
      {
        text: "SL",
        align: "left",
        sortable: true,
        value: "id",
        width: '5%'
      },
      {
        text: "Package Number",
        align: "left",
        sortable: true,
        value: "package_no",
        width: '10%'
      },

      {
        text: "Package Name",
        align: "left",
        sortable: true,
        value: "name",
        width: '20%'
      },
      {
        text: "Modefication",
        align: "left",
        sortable: true,
        value: "name",
        width: "20px", 
        fixed: true
      },
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "status_id",
        width: '5%'
      },
      
      {
        text: "Procurement Type",
        align: "left",
        sortable: true,
        value: "type_name",
        width: '10%'
      },
      // {
      //   text: "Unit",
      //   align: "left",
      //   sortable: true,
      //   value: "unit_name",
      // },
      // {
      //   text: "Quantity",
      //   align: "left",
      //   sortable: true,
      //   value: "quantity",
      // },
      {
        text: "Estimated Price",
        align: "left",
        sortable: true,
        value: "estimated_price",
        width: '10%'
      },
      {
        text: "Method",
        align: "left",
        value: "method_name",
        width: '10%'
      },
      {
        text: "Start Date",
        align: "left",
        value: "from_date",
        width: '5%'
      },
    
      {
        text: "Action",
        align: "left",
        value: "",
        width: '5%'
      },
    ],

    items: [],

    delete_id: "",
    row_index: "",
    confirmModel: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",
    projectId: sessionStorage.getItem('proId'),
    leaveTypeModal: false,
    formSchema: {
      id: "",
      name: "",
      from_date: "",
      to_date: "",
      procurement_type_id: "",
      beneficiary_name: "",
      quantity: "",
      unit_id: "",
      estimated_price: "",
      method_id: "",
      status_id: "",
      contract_type: "",
      remarks: ""
    },
   
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
  }),


  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },

   userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    },
    _link() {
      sessionStorage.removeItem("package_info");
      sessionStorage.setItem("package_status", "new")
      return "/procurement/new_package";
    },

  },
  /*------------/Datatable------------*/

  methods: {
    addDetails(items)
    {
      sessionStorage.setItem("pacId", items.id); 
      sessionStorage.setItem("pacVersionId", items.package_versions_id); 
      this.$router.push('/procurement/package-details');
    },
    loadData(pagination) {
      commonService.getAllData("proc_packages").then((res) => {
        this.items = res.data;
        this.loading = false;
      });
    },


    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService.getServerSideData(query_Data, "procurement-package-info").then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    getDataFromApiXX() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
          this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "procurement-package-info")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            // if (rowsPerPage > 0) {
            //   items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
            // }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    editItem(index, item, type) {
      this.row_index = index;
      this.formSchema = item;
      
      if(type == 'copy'){ 
        sessionStorage.setItem("is_edit",false);
      }else{
        sessionStorage.setItem("is_edit",true);
      } 

      sessionStorage.setItem("package_info", item.id);
      sessionStorage.setItem("package_status", "update")
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth",
      });
      this.$router.push("/procurement/new_package");
    },

    deleteItem(index, id) {
      this.row_index = index - 1;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "proc_packages").then((res) => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.SnackbarVal.color = "success";
          // this.SnackbarVal.message = res.message;
          // this.SnackbarVal.snackbar = true;
          // this.confirmModel = false;
          // this.dialog2 = false;
        } else {
          this.SnackbarVal.color = "error"; 
          this.SnackbarVal.message = "Try again!";
          this.SnackbarVal.snackbar = true;
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close(data) {
      this.leaveTypeModal = false;
      if (data.status == 1) {
        this.data = data;
        this.message = data.message;
        this.snackbar = true;
        this.getDataFromApi();
      }
    },
  },

  mounted() {
    // this.loadData();
    this.SnackbarVal.color = "success";
    this.SnackbarVal.message = "Data Loading";
    this.SnackbarVal.snackbar = true;
    
  },
};
</script>

<style scoped>
#customers td, #customers th {
  border: 2px solid #ddd;
  padding: 8px;
  text-align: left;
  width:1%;
  white-space:nowrap;
}

#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #ddd;}

#customers th {
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background:green;
  color: white;
  overflow: hidden;
}
#auto{
  height:70vh !important;
  width: 100%;
  overflow-x: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/procurement/package/package_list.vue